import { createContext, useReducer } from "react";
import reducer from "./Reducer";


export const CartContext = createContext()

const CartContextProvider = ({children}) => {
  const initstate = []
  const [state,dispatch]=useReducer(reducer,initstate)
    let value = {state,dispatch}
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}
export default CartContextProvider